import {createStore, applyMiddleware, compose} from "redux";
import reducer from "./reducer";
import api from "../../../middlewares/api";
import thunk from "redux-thunk";
import {routerMiddleware} from "connected-react-router";
import history from "../../common/Router/history";

const IS_BROWSER = typeof window === `object`;

const composeEnhancers =
  IS_BROWSER && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const middlewares = [
  thunk,
  api,
  IS_BROWSER
    ? routerMiddleware(history)
    : () => (next) => (action) => {
        next(action);
      }
];

const enhancer = composeEnhancers(applyMiddleware.apply(this, middlewares));

const createStoreForSSR = (initialStore) =>
  createStore(reducer, initialStore, enhancer);

export default createStoreForSSR;
